import { createSlice } from '@reduxjs/toolkit'

const getDefaultOptions = () => ({
  message: '',
  type: 'info',
  icon: '',
  width: undefined, // mặc định ôm theo nội dung (max 480px)
  dismissible: false,
  timeout: 3000,
  visible: true
})

const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    alerts: []
  },
  reducers: {
    ADD_ALERT: (state, action) => {
      state.alerts.push(action.payload)
    },
    DELETE_ALERT: (state, action) => {
      const index = state.alerts.findIndex((alert) => alert.id === action.payload.id)
      if (index !== -1) {
        state.alerts.splice(index, 1)
      }
    }
  }
})

export const { ADD_ALERT, DELETE_ALERT } = alertSlice.actions

/**
 * @param {Object} options
 * @param {string} [options.message]
 * @param {string} [options.type]
 * @param {string} [options.icon]
 * @param {string} [options.width] - mặc định ôm theo nội dung
 * @param {boolean} [options.dismissible=false]
 * @param {number} [options.timeout=3000]
 */
let nextAlertId = 0

export const notify = (options) => (dispatch) => {
  const alert = { ...getDefaultOptions(), ...options, id: ++nextAlertId }

  dispatch(ADD_ALERT(alert))

  setTimeout(() => {
    dispatch(DELETE_ALERT({ id: alert.id }))
  }, alert.timeout || 1000)
}

export default alertSlice.reducer
